module.exports = __webpack_public_path__ + "img/9353b600-0e54-11ea-9712-b79b66b93c00-min.85458a67.png";